import type { FaireProductEntity } from "../../entity_types/product";

export const p_6pevdv9i6n: FaireProductEntity = {
  token: "p_6pevdv9i6n",
  type: "product",
  name: "Pogo Panda Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/322ec1a5d5f01dcc58c2f2eda2639e0d372ecfe6509eebcae9ba65ec4135dcb9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24f497af72e68e062a65df07a9d02729f5ba5b2e88afe0cb525db0f7f8e567cf.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:56.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
